module.exports = __webpack_public_path__ + "img/公司业务—研究.2d731b11.jpg";